import useSocketReconnect from '../../../utils/useSocketReconnect';
import { useEffect, useRef, useState } from "react"
import moment from "moment";
import { applyTimeZone } from "../../../utils/utils";

function DuplicarProves({ socket, setClosed, toEvent, modelFolders }) {
    useSocketReconnect(socket, () => {
        socket.emit('.request_all_events');
    });

    const [error, setError] = useState('');
    const [events, setEvents] = useState(null)
    const [fromEvent, setFromEvent] = useState(null)
    const eventRefs = useRef([]);

    const duplicar_proves = async () => {
        if (fromEvent === null) return null;
        if (fromEvent === toEvent) return null;

        if (String(toEvent) === '999999' && modelFolders) {
            try {
                await modelFolders.mutate('proves/copy', { fromEvent, folderId: modelFolders.folderId });
                setClosed(true);
            } catch (err) { setError(err.message); }
            return;
        }
        socket.emit('.duplicar_proves', fromEvent, toEvent)
        socket.emit('.request_proves', toEvent)
        socket.emit('.request_order', toEvent)
        setClosed(true)
    }

    useEffect(() => {
        socket.emit('.request_all_events')
        const onEvents = events => setEvents(
            events.sort((a,b) => new Date(a['data-esperada-inici']) > new Date(b['data-esperada-inici']) ? 1 : -1)
        )
        socket.on('.events', onEvents)
        return () => socket.off('.events', onEvents)
    }, [])
    
    useEffect(() => {
        if (events) {
            const toEventIndex = events.findIndex(
                event => parseInt(event.id) === parseInt(toEvent)
            )

            if (toEventIndex >= 0) {
                eventRefs.current[toEventIndex].scrollIntoView({
                    // behavior: 'smooth',
                    block: 'nearest'
                });
            }
        }
    }, [events]);

    return (
        <div>
            <div style={{height: '150px', overflowY: 'scroll'}}>
                {events?.map((event, index) => (
                    <div key={event.id} 
                        ref={el => eventRefs.current[index] = el}
                        onClick={() => setFromEvent(event.id)}
                        style={{
                            padding: '10px',
                            backgroundColor:
                                fromEvent === event.id ? 'lightblue' :
                                toEvent === event.id ? '#eee' :
                                'transparent',
                            color: toEvent === event.id ? '#aaa' : 'black',
                            fontStyle: toEvent === event.id ? 'italic' : 'normal',
                            cursor: 'pointer'
                        }}
                    >
                        {event.title} - {applyTimeZone(event['data-esperada-inici']).format('DD/MM/YYYY HH:mm')}
                    </div>
                ))}
            </div>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '10px'
                }}
            >
                <button disabled={modelFolders?.busy} onClick={duplicar_proves}>{modelFolders?.busy ? 'Copiant…' : 'Duplicar proves'}</button>
                {error && <p role="alert">{error}</p>}
            </div>
        </div>
    )
}

export default DuplicarProves;